import { Component, OnInit, ViewChild } from "@angular/core";
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { ActivityStoreFacade } from "../../../common/facade/ActivityStoreFacade";
import { ActivatedRoute} from '@angular/router';
import { Router, NavigationExtras } from '@angular/router';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';

@Component({
    selector: "app-reportstorepricechange",
    templateUrl: "./reportstorepricechange.component.html"
})

export class ReportStorePriceChangeComponent
    implements OnInit {

    //Properties and Attributes
    lblSearch = res.Search;
    lblSection = res.Section;
    lblGender = res.Gender;
    lblProgress = res.Progress;
    messagesTable : any = {
        emptyMessage: "",
        totalMessage: "" 
    }
    
    @ViewChild('tableChanges') tableChanges: DatatableComponent;
    TitleActivity: string = "";
    loading = false;
    messageLoader = '';
    message = '';
    modalTitle = '';
    rows: any = [];
    private _filteredData = [];
    private _activStoreId: number=0;

    //alert
    alerts: any[] = [];

    //Constructor
    constructor(
        private _facade: ActivityStoreFacade,
        private route: ActivatedRoute,
        private _router: Router,
        public strings: Strings
    ) 
    {
    }

    //EventHandlers
    ngOnInit() {
        const navigation = this.route.queryParams.subscribe(params => {
            this._activStoreId = Number(params["pActvStrd"])
                , this.TitleActivity = params["pTitleActivity"] + ' - ' +  params["pStoreName"]
          });

         
        this.loading = true;
        this.messageLoader = "Cargando Información";
        this._facade.GetPriceSummary(this._activStoreId).subscribe(result => {
            if(result.completed)
            {
                this.rows = result.data;
                this._filteredData = result.data;
            }

            this.loading = false;
        }, error => 
        {
            this.addAlert('<strong>'+error+'</strong>','danger')
            this.loading = false;
        });
    }

    onViewDetail(sectionId: any, genderId:any) {
        var routeTo = ""
        let navigationExtras: NavigationExtras = {
            queryParams: {
                "pActvStrd": this._activStoreId,
                "pSecId": sectionId,
                "pGendId": genderId
            }
        };
        
        routeTo = 'views/task/report/store/priceadvance'
        
        this._router.navigate([routeTo], navigationExtras).then((e) => {
            if (e) { }
            else {
                console.log(e);
            }
        });
    }

    updateFilter(event) {
        let val = event.target.value.toLowerCase();

        let keys = Object.keys(this._filteredData[0]);
        this.rows = this._filteredData.filter(function (item) {
            for (let i = 0; i < keys.length; i++) {

                if (item[keys[i]] != null &&
                    (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) 
                {
                    return true;
                }
            }
        });

        this.tableChanges.offset = 0;
    }

    // añadir alert
    addAlert(message: String, type: String): void {
        this.alerts = []
        this.alerts.push({
            type: type,
            msg: message
        });
    }

    // cerrar alert
    onClosed(dismissedAlert: AlertComponent): void 
    {
        this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
    }
}